export const mockProducts = [
  {
    id: '1',
    name: '云朵系列猫抓板',
    category: '瓦楞纸',
    price: 68,
    originalPrice: 98,
    description: '采用三层高密度瓦楞纸压制，注入天然猫薄荷，让猫咪爱不释手。云朵造型圆润可爱，与家居完美融合。',
    longDescription: '云朵系列猫抓板是 Koorpet 的明星产品，自上市以来深受广大铲屎官喜爱。产品采用进口高密度瓦楞纸，经过三层热压工艺制成，密度达到普通产品的2倍，耐抓耐磨，使用寿命更长。\n\n独特的云朵造型不仅美观，更符合猫咪的抓挠习惯。底部配备防滑橡胶垫，使用时稳固不移位。产品在生产过程中均匀注入有机猫薄荷，持久散发天然香气，让猫咪主动靠近使用，有效保护家具。\n\n所有原材料均通过国家环保检测，无甲醛、无重金属，猫咪啃咬也安全放心。',
    image: 'https://readdy.ai/api/search-image?query=cute%20cloud%20shaped%20cat%20scratching%20board%20made%20of%20corrugated%20cardboard%2C%20minimalist%20white%20background%2C%20product%20photography%2C%20warm%20beige%20tones%2C%20soft%20lighting%2C%20high%20quality%20pet%20product%20shot%2C%20clean%20studio%20background&width=400&height=400&seq=prod1&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=cute%20cloud%20shaped%20cat%20scratching%20board%20corrugated%20cardboard%2C%20clean%20white%20studio%20background%2C%20warm%20beige%20tones%2C%20product%20photography%2C%20front%20view&width=600&height=600&seq=prod1a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20scratching%20board%20close%20up%20texture%20detail%2C%20corrugated%20cardboard%20layers%2C%20warm%20natural%20tones%2C%20macro%20photography%2C%20clean%20background&width=600&height=600&seq=prod1b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=orange%20tabby%20cat%20happily%20scratching%20on%20cloud%20shaped%20cardboard%20scratcher%2C%20cozy%20home%20interior%2C%20warm%20natural%20light%2C%20lifestyle%20pet%20photography&width=600&height=600&seq=prod1c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20scratching%20board%20bottom%20anti-slip%20rubber%20pad%20detail%2C%20product%20photography%2C%20clean%20white%20background%2C%20close%20up%20view&width=600&height=600&seq=prod1d&orientation=squarish',
    ],
    tags: ['热销', '猫薄荷'],
    isFeatured: true,
    specs: { material: '高密度瓦楞纸', size: '45×30×8cm', weight: '680g' },
    highlights: [
      { icon: 'ri-stack-line', title: '三层热压工艺', desc: '密度是普通产品2倍，更耐抓' },
      { icon: 'ri-leaf-line', title: '有机猫薄荷注入', desc: '持久香气，猫咪主动靠近' },
      { icon: 'ri-shield-check-line', title: '环保无毒认证', desc: '啃咬也安全放心' },
      { icon: 'ri-footprint-line', title: '防滑底部设计', desc: '使用时稳固不移位' },
    ],
    faqs: [
      { q: '猫薄荷的香味能持续多久？', a: '在正常使用条件下，猫薄荷香味可持续约3-6个月。如需加强效果，可购买我们配套的猫薄荷喷雾。' },
      { q: '猫抓板磨损后可以更换吗？', a: '本产品为一体式设计，磨损后建议整体更换。通常正常使用寿命为3-6个月，具体取决于猫咪的使用频率。' },
      { q: '适合多大的猫咪使用？', a: '适合所有体型的猫咪，从幼猫到成猫均可使用。产品尺寸45×30cm，足够大型猫咪舒展使用。' },
    ],
  },
  {
    id: '2',
    name: '原木猫抓柱',
    category: '剑麻',
    price: 128,
    originalPrice: 168,
    description: '天然剑麻绳缠绕，原木底座稳固不晃动，高度适中满足猫咪伸展需求，耐磨耐抓使用寿命长。',
    longDescription: '原木猫抓柱采用天然剑麻绳手工缠绕，每根剑麻绳均经过严格筛选，确保粗细均匀、韧性十足。原木底座选用优质松木，经过防腐处理，稳固耐用。\n\n60cm的高度设计，完美满足猫咪站立伸展抓挠的自然需求，有效锻炼猫咪肌肉，保持健康体态。底座面积足够宽大，即使大型猫咪用力抓挠也不会倾倒。\n\n剑麻材质天然粗糙，是猫咪磨爪的理想材料，能有效修剪猫爪，减少猫咪抓挠家具的行为。',
    image: 'https://readdy.ai/api/search-image?query=natural%20sisal%20rope%20cat%20scratching%20post%20with%20wooden%20base%2C%20minimalist%20product%20photography%2C%20warm%20natural%20tones%2C%20clean%20white%20studio%20background%2C%20high%20quality%20pet%20furniture%20shot&width=400&height=400&seq=prod2&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=natural%20sisal%20rope%20cat%20scratching%20post%20wooden%20base%2C%20clean%20white%20studio%20background%2C%20warm%20natural%20tones%2C%20full%20product%20view&width=600&height=600&seq=prod2a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=sisal%20rope%20texture%20close%20up%20detail%2C%20natural%20fiber%20macro%20photography%2C%20warm%20brown%20tones%2C%20clean%20background&width=600&height=600&seq=prod2b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20scratching%20sisal%20post%20in%20modern%20home%2C%20lifestyle%20photography%2C%20warm%20interior%2C%20happy%20cat%20using%20scratching%20post&width=600&height=600&seq=prod2c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=wooden%20base%20of%20cat%20scratching%20post%2C%20pine%20wood%20detail%2C%20product%20photography%2C%20clean%20white%20background%2C%20close%20up&width=600&height=600&seq=prod2d&orientation=squarish',
    ],
    tags: ['新品', '剑麻'],
    isFeatured: true,
    specs: { material: '天然剑麻 + 实木', size: 'Φ12×60cm', weight: '1.2kg' },
    highlights: [
      { icon: 'ri-plant-line', title: '天然剑麻绳', desc: '手工缠绕，粗细均匀韧性足' },
      { icon: 'ri-home-3-line', title: '实木底座', desc: '松木防腐处理，稳固不倒' },
      { icon: 'ri-arrow-up-line', title: '60cm黄金高度', desc: '满足猫咪站立伸展需求' },
      { icon: 'ri-scissors-line', title: '自然修爪', desc: '有效修剪猫爪，保护家具' },
    ],
    faqs: [
      { q: '剑麻绳会不会散开？', a: '我们采用专业缠绕工艺，绳头经过特殊固定处理，正常使用不会散开。如出现松动，可联系客服处理。' },
      { q: '底座会不会在地板上留下划痕？', a: '底座底部贴有防滑毡垫，不会划伤地板，同时防止使用时滑动。' },
      { q: '剑麻绳磨损后可以更换吗？', a: '可以！我们提供剑麻绳替换服务，购买替换绳后可自行缠绕，延长产品使用寿命。' },
    ],
  },
  {
    id: '3',
    name: '波浪猫抓板',
    category: '瓦楞纸',
    price: 45,
    originalPrice: 65,
    description: '波浪形设计符合猫咪抓挠习惯，可翻面使用双倍寿命，底部防滑设计使用更安全。',
    longDescription: '波浪猫抓板以其独特的波浪形曲面设计，完美契合猫咪抓挠时的自然姿势。无论是站立抓挠还是趴卧磨爪，波浪形态都能提供最舒适的接触面。\n\n产品最大亮点是双面可用设计——当一面磨损后，翻转即可继续使用，相当于买一送一，极具性价比。底部配备防滑橡胶条，使用时稳固不移位。\n\n采用高密度瓦楞纸制作，纸屑少、不易碎，保持家居整洁。',
    image: 'https://readdy.ai/api/search-image?query=wave%20shaped%20corrugated%20cardboard%20cat%20scratcher%20pad%2C%20minimalist%20product%20photography%2C%20warm%20beige%20and%20brown%20tones%2C%20clean%20white%20studio%20background%2C%20high%20quality%20pet%20product%20shot&width=400&height=400&seq=prod3&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=wave%20shaped%20corrugated%20cardboard%20cat%20scratcher%2C%20clean%20white%20studio%20background%2C%20warm%20beige%20tones%2C%20full%20product%20view%2C%20side%20angle&width=600&height=600&seq=prod3a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=corrugated%20cardboard%20wave%20scratcher%20top%20view%2C%20texture%20detail%2C%20warm%20natural%20tones%2C%20product%20photography%2C%20clean%20background&width=600&height=600&seq=prod3b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20lying%20on%20wave%20shaped%20cardboard%20scratcher%2C%20cozy%20home%20setting%2C%20warm%20light%2C%20lifestyle%20pet%20photography&width=600&height=600&seq=prod3c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20scratcher%20anti-slip%20bottom%20rubber%20strip%20detail%2C%20product%20photography%2C%20clean%20white%20background&width=600&height=600&seq=prod3d&orientation=squarish',
    ],
    tags: ['双面可用'],
    isFeatured: true,
    specs: { material: '高密度瓦楞纸', size: '50×25×6cm', weight: '520g' },
    highlights: [
      { icon: 'ri-refresh-line', title: '双面可用', desc: '翻转继续使用，寿命翻倍' },
      { icon: 'ri-water-flash-line', title: '波浪曲面设计', desc: '契合猫咪自然抓挠姿势' },
      { icon: 'ri-drop-line', title: '低粉尘配方', desc: '纸屑少，保持家居整洁' },
      { icon: 'ri-footprint-line', title: '防滑橡胶条', desc: '使用时稳固不移位' },
    ],
    faqs: [
      { q: '波浪形状会不会让猫咪不适应？', a: '波浪形设计经过大量猫咪行为学研究，符合猫咪自然抓挠姿势，大多数猫咪会很快适应并喜爱。' },
      { q: '使用时会产生很多纸屑吗？', a: '我们采用低粉尘配方的高密度瓦楞纸，相比普通产品纸屑减少约60%，日常清洁更方便。' },
      { q: '两面的使用寿命一样吗？', a: '两面材质完全相同，使用寿命一致。建议一面磨损约50%时翻面，可以最大化产品使用寿命。' },
    ],
  },
  {
    id: '4',
    name: '猫抓板沙发护角',
    category: '剑麻',
    price: 39,
    originalPrice: 55,
    description: '专为保护沙发设计，剑麻材质耐抓耐磨，安装简便无需工具，有效转移猫咪抓挠目标。',
    longDescription: '猫抓板沙发护角是专为有猫家庭设计的沙发保护神器。采用天然剑麻材质，提供猫咪喜爱的抓挠触感，有效将猫咪的抓挠行为从沙发转移到护角上。\n\n安装极为简便，无需任何工具，通过背面的强力魔术贴即可牢固固定在沙发角上，不损伤沙发面料。适配市面上大多数沙发角尺寸。\n\n一套包含4个护角，可同时保护沙发的四个角，全方位守护您的沙发。',
    image: 'https://readdy.ai/api/search-image?query=sisal%20cat%20scratch%20sofa%20corner%20protector%2C%20minimalist%20product%20photography%2C%20natural%20fiber%20texture%2C%20clean%20white%20studio%20background%2C%20high%20quality%20pet%20accessory%20shot&width=400&height=400&seq=prod4&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=sisal%20sofa%20corner%20protector%20cat%20scratcher%2C%20clean%20white%20studio%20background%2C%20natural%20fiber%20texture%2C%20full%20product%20view&width=600&height=600&seq=prod4a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=sisal%20fiber%20texture%20close%20up%20macro%20photography%2C%20natural%20brown%20tones%2C%20clean%20background%2C%20detail%20shot&width=600&height=600&seq=prod4b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20scratching%20sofa%20corner%20protector%20installed%20on%20couch%2C%20home%20interior%2C%20lifestyle%20photography%2C%20warm%20tones&width=600&height=600&seq=prod4c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=velcro%20adhesive%20back%20of%20sofa%20protector%2C%20product%20detail%20photography%2C%20clean%20white%20background%2C%20close%20up&width=600&height=600&seq=prod4d&orientation=squarish',
    ],
    tags: ['护沙发'],
    isFeatured: false,
    specs: { material: '天然剑麻', size: '30×20×5cm', weight: '280g' },
    highlights: [
      { icon: 'ri-sofa-line', title: '专为沙发设计', desc: '完美贴合沙发角，全方位保护' },
      { icon: 'ri-tools-line', title: '免工具安装', desc: '强力魔术贴，30秒搞定' },
      { icon: 'ri-shield-line', title: '不损伤沙发', desc: '背面保护层，不留痕迹' },
      { icon: 'ri-gift-line', title: '一套4个', desc: '同时保护沙发四个角' },
    ],
    faqs: [
      { q: '魔术贴会不会损伤沙发面料？', a: '我们使用特殊配方的无痕魔术贴，对大多数沙发面料无损伤。建议在皮质沙发上使用前先在不显眼处测试。' },
      { q: '适合什么尺寸的沙发角？', a: '护角尺寸为30×20cm，适配市面上90%以上的沙发角尺寸。如沙发角特别大或特别小，建议联系客服确认。' },
      { q: '猫咪会不会把护角扯下来？', a: '强力魔术贴固定力强，普通猫咪抓挠不会脱落。如猫咪特别有力，可配合双面胶加固。' },
    ],
  },
  {
    id: '5',
    name: '猫薄荷圆形猫抓板',
    category: '瓦楞纸',
    price: 58,
    originalPrice: 78,
    description: '圆形设计美观大方，内嵌猫薄荷颗粒，猫咪闻到香味自动靠近，解决猫咪不爱用抓板的烦恼。',
    longDescription: '猫薄荷圆形猫抓板专为那些对普通猫抓板不感兴趣的猫咪设计。产品在制作过程中将有机猫薄荷颗粒均匀嵌入瓦楞纸层间，猫咪闻到香味会自然靠近并开始抓挠，有效解决猫咪不爱用抓板的烦恼。\n\n圆形设计美观大方，直径38cm，足够大型猫咪使用。可平放地面使用，也可挂墙展示，一物两用。产品边缘经过特殊处理，不会有毛刺，猫咪使用安全。\n\n高密度瓦楞纸制作，耐抓耐磨，使用寿命长。',
    image: 'https://readdy.ai/api/search-image?query=round%20circular%20cat%20scratching%20board%20with%20catnip%2C%20corrugated%20cardboard%2C%20minimalist%20product%20photography%2C%20warm%20tones%2C%20clean%20white%20studio%20background%2C%20high%20quality%20pet%20product%20shot&width=400&height=400&seq=prod5&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=round%20circular%20corrugated%20cardboard%20cat%20scratcher%2C%20clean%20white%20studio%20background%2C%20warm%20beige%20tones%2C%20top%20view%20product%20photography&width=600&height=600&seq=prod5a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=catnip%20herbs%20scattered%20on%20cat%20scratcher%2C%20close%20up%20macro%20photography%2C%20green%20and%20beige%20tones%2C%20natural%20background&width=600&height=600&seq=prod5b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20rolling%20and%20playing%20on%20round%20cardboard%20scratcher%2C%20cozy%20home%20setting%2C%20warm%20light%2C%20happy%20pet%20lifestyle%20photography&width=600&height=600&seq=prod5c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=round%20cat%20scratcher%20hanging%20on%20wall%20as%20decoration%2C%20modern%20home%20interior%2C%20minimalist%20style%2C%20lifestyle%20photography&width=600&height=600&seq=prod5d&orientation=squarish',
    ],
    tags: ['猫薄荷', '热销'],
    isFeatured: false,
    specs: { material: '高密度瓦楞纸', size: 'Φ38×5cm', weight: '450g' },
    highlights: [
      { icon: 'ri-leaf-line', title: '有机猫薄荷内嵌', desc: '解决猫咪不爱用抓板难题' },
      { icon: 'ri-circle-line', title: '圆形美观设计', desc: '可平放可挂墙，一物两用' },
      { icon: 'ri-safe-line', title: '边缘安全处理', desc: '无毛刺，猫咪使用安全' },
      { icon: 'ri-star-line', title: '热销爆款', desc: '月销超5000件，好评如潮' },
    ],
    faqs: [
      { q: '猫薄荷对猫咪安全吗？', a: '完全安全！我们使用的是有机种植的猫薄荷，不含任何添加剂，猫咪食用也无害。猫薄荷对猫咪有天然的吸引力，是完全正常的生理反应。' },
      { q: '可以挂在墙上吗？', a: '可以！产品背面预留了挂孔，可以直接挂在墙上作为装饰，同时猫咪也可以站立抓挠使用。' },
      { q: '猫薄荷香味消失后还能用吗？', a: '当然可以！即使猫薄荷香味消退，产品仍然是优质的猫抓板。您也可以购买我们的猫薄荷喷雾，随时补充香气。' },
    ],
  },
  {
    id: '6',
    name: '豪华猫爬架抓柱',
    category: '综合',
    price: 298,
    originalPrice: 398,
    description: '多层设计集猫抓、休息、玩耍于一体，剑麻抓柱 + 毛绒平台，满足猫咪全方位需求，稳固不倒。',
    longDescription: '豪华猫爬架抓柱是 Koorpet 的旗舰产品，集猫抓、休息、玩耍、观察于一体，是猫咪的专属城堡。产品采用实木框架，表面覆盖优质毛绒，触感柔软舒适。\n\n三层平台设计，满足猫咪喜欢高处的天性。每层平台均经过承重测试，可承受15kg以上的重量，适合多猫家庭使用。底部四根剑麻抓柱，提供充足的磨爪空间。\n\n顶部配备悬挂玩具，激发猫咪玩耍兴趣。整体结构稳固，底盘宽大，即使猫咪跳跃也不会倾倒。',
    image: 'https://readdy.ai/api/search-image?query=luxury%20multi-level%20cat%20tree%20with%20sisal%20scratching%20posts%20and%20plush%20platforms%2C%20minimalist%20product%20photography%2C%20natural%20wood%20and%20beige%20tones%2C%20clean%20white%20studio%20background%2C%20high%20quality%20pet%20furniture&width=400&height=400&seq=prod6&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20multi-level%20cat%20tree%20tower%20with%20sisal%20posts%20and%20plush%20platforms%2C%20clean%20white%20studio%20background%2C%20full%20product%20view%2C%20warm%20natural%20tones&width=600&height=600&seq=prod6a&orientation=squarish',
      'https://readdy.ai/api/search-image?query=plush%20platform%20of%20cat%20tree%20close%20up%2C%20soft%20beige%20fabric%20texture%2C%20product%20detail%20photography%2C%20clean%20background&width=600&height=600&seq=prod6b&orientation=squarish',
      'https://readdy.ai/api/search-image?query=two%20cats%20playing%20on%20multi-level%20cat%20tree%2C%20cozy%20home%20interior%2C%20warm%20natural%20light%2C%20lifestyle%20pet%20photography&width=600&height=600&seq=prod6c&orientation=squarish',
      'https://readdy.ai/api/search-image?query=cat%20tree%20base%20and%20sisal%20scratching%20post%20detail%2C%20product%20photography%2C%20clean%20white%20background%2C%20close%20up%20view&width=600&height=600&seq=prod6d&orientation=squarish',
    ],
    tags: ['爆款', '多功能'],
    isFeatured: false,
    specs: { material: '剑麻 + 实木 + 毛绒', size: '50×50×120cm', weight: '8.5kg' },
    highlights: [
      { icon: 'ri-building-line', title: '三层平台设计', desc: '满足猫咪喜欢高处的天性' },
      { icon: 'ri-shield-check-line', title: '承重15kg+', desc: '多猫家庭也能放心使用' },
      { icon: 'ri-gamepad-line', title: '悬挂玩具配件', desc: '激发猫咪玩耍兴趣' },
      { icon: 'ri-home-smile-line', title: '宽大稳固底盘', desc: '跳跃也不倾倒' },
    ],
    faqs: [
      { q: '安装复杂吗？需要多长时间？', a: '产品附带详细图文安装说明，一般1-2人配合约30-45分钟可完成安装。所有配件和工具均已包含在包装内。' },
      { q: '适合多大的猫咪？', a: '适合所有体型的猫咪，包括大型猫种如缅因猫、布偶猫等。每层平台承重15kg，完全满足大型猫咪需求。' },
      { q: '毛绒平台脏了怎么清洁？', a: '毛绒平台可拆卸，支持手洗或机洗（建议30°C以下），晾干后重新安装即可。建议每月清洗一次。' },
    ],
  },
];

export const mockCategories = ['全部', '瓦楞纸', '剑麻', '综合'];

export const mockReviews = [
  {
    id: '1',
    name: '橘猫妈妈',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20cat%20owner%20avatar%2C%20warm%20illustration%20style%2C%20simple%20background%2C%20friendly%20face&width=80&height=80&seq=avatar1&orientation=squarish',
    rating: 5,
    content: '买了云朵系列，我家橘猫第一天就爱上了！质量超好，纸板很厚实，猫薄荷味道也很吸引它，强烈推荐！',
    product: '云朵系列猫抓板',
    date: '2026-03-15',
  },
  {
    id: '2',
    name: '布偶铲屎官',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20pet%20owner%20avatar%2C%20warm%20illustration%20style%2C%20simple%20background%2C%20happy%20expression&width=80&height=80&seq=avatar2&orientation=squarish',
    rating: 5,
    content: '原木猫抓柱做工精细，剑麻绳缠绕很紧实，底座稳得很，我家布偶猫每天都在上面磨爪子，沙发终于保住了！',
    product: '原木猫抓柱',
    date: '2026-03-20',
  },
  {
    id: '3',
    name: '三花猫的主人',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20cat%20lover%20avatar%2C%20warm%20illustration%20style%2C%20simple%20background%2C%20smiling%20face&width=80&height=80&seq=avatar3&orientation=squarish',
    rating: 5,
    content: '波浪猫抓板设计很聪明，可以翻面用，性价比极高。猫咪很喜欢趴在上面睡觉，一举两得！',
    product: '波浪猫抓板',
    date: '2026-04-01',
  },
  {
    id: '4',
    name: '英短爸爸',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20cartoon%20male%20cat%20owner%20avatar%2C%20warm%20illustration%20style%2C%20simple%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar4&orientation=squarish',
    rating: 5,
    content: '包装很用心，产品质量没话说。客服响应也很快，有问题秒回。已经回购三次了，是我家猫咪的最爱品牌！',
    product: '猫薄荷圆形猫抓板',
    date: '2026-04-10',
  },
];
